<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-kyc_status_approved"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      :type="'checkbox'"
      :checkbox_checked_value="true"
      :disabled="true"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "KycStatusApproved",
  components: {InputWidget},
  mixins: [BaseInputMixin('term.kyc_status_approved')],

  data() {
    return {
      defaultLabel: this.$t("KYC Status Approved")
    }
  }
}
</script>

<style scoped>

</style>
